<template>
  <section id="home-k-feature" class="row no-gutters">
    <Item v-for="(item, index) in items" :key="index" :data="item" :idx="index" />
  </section>
</template>

<script>
import Item from './item.vue';
export default {
  components: { Item },
  data() {
    return {
      items: [
        {
          name: 'Super',
          desc: 'Conventional Wiper Blade',
          to: { name: 'product', params: { name: "_super" } }
        },
        {
          name: 'SQ4M',
          desc: 'Beam Wiper Blade',
          to: { name: 'product', params: { name: "sq4m" } }
        },
        {
          name: 'Winter6',
          desc: 'Snow Wiper Blade',
          to: { name: 'product', params: { name: "w6" } }
        }
      ]
    }
  },
}
</script>

<style lang="scss">
</style>